export default '6.0.0-beta.2';
